import * as Yup from "yup";
import { OptionType } from "../../../slices/users/types";

export const BUTTONS = [
    { name: "Back", className: "cancelBtn" },
  ];
  
  export const contentDetails = [
    {label:'Name', name:'firstName'},
    {label:'JobTitle', name:'jobTitle'},
    {label:'Mobile', name:'mobileNumber'},
    {label:'State', name:'state'},
    {label:'Email', name:'email'},
    {label:'Job Title', name:'jobTitle'},
    {label:'Created At', name:'createdAt'},
    {label:'Note', name:'note'},
  ]
  
  export const STATE_VALUES = [
    { value: "", label: "Please Select", isDisabled: true },
    { value: "Active", label: "Active", isDisabled: false },
    { value: "Inactive", label: "Inactive", isDisabled: false },
  ]
  
  export const DELETE_MODAL_SUB_TITLE = "Are you sure you want to delete this item?";
  export const DELETE_MODAL_TITLE = "Delete Item"

    // Define validation schema using Yup
export const ValidationSchema = Yup.object().shape({
      firstName: Yup.string().required("Please enter first name"),
      lastName: Yup.string().required("Please enter last name"),
      mobileNumber: Yup.string().required("Please enter mobile number"),
      state: Yup.object().nullable().required("Please select a state"),
      jobTitle: Yup.string().required("Please enter job title"),
    });

export const  REQUESTED_USER_REQUEST_OPTIONS= [
      { value: '', label: 'Please Select', isDisabled: true },
      {value:2, label:"Approve"},
      {value:3, label:"Reject"}
  ];

export const USER_REQUEST_OPTIONS  = [
    { value: '', label: 'Please Select', isDisabled: true },
    { value: 2, label: "Active" },
    { value: 3, label: "Inactive" },
];


// Keys are backend UserType names, sent as the role filter.
export const USER_ROLE_LABELS: Record<string, string> = {
  GlobalAdmin: "Global Admin",
  Administrator: "Admin",
  Operator: "Operator",
  Customer: "Customer",
};

// Global Admins are only visible to other Global Admins.
const getVisibleUserRoles = (includeGlobalAdmin: boolean) =>
  Object.keys(USER_ROLE_LABELS).filter(
    (role) => includeGlobalAdmin || role !== "GlobalAdmin"
  );

export const getAllUserRoles = (includeGlobalAdmin: boolean) =>
  getVisibleUserRoles(includeGlobalAdmin).join(",");

export const getUserRoleFilterOptions = (includeGlobalAdmin: boolean) => [
  { value: getAllUserRoles(includeGlobalAdmin), label: "All roles" },
  ...getVisibleUserRoles(includeGlobalAdmin).map((role) => ({
    value: role,
    label: USER_ROLE_LABELS[role],
  })),
];

export  const userStatusData: OptionType[] = [
  { value: 1, label: "All" },
  { value: 2, label: "Active" },
  { value: 3, label: "Inactive" },
];

export const requestedUserStatusData: OptionType[] = [
  { value: 1, label: 'All' },
  { value: 2, label: 'Requested' },
  { value: 3, label: 'Rejected'}
];